import { CaretLeft, CaretRight } from 'phosphor-react';
import React from 'react';
import * as S from '../styles';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const renderPageNumbers = () => {
    const pages: any[] = [];

    // Always show first page
    if (currentPage > 3) {
      pages.push(
        <S.PageButton key="1" onClick={() => onPageChange(1)}>
          1
        </S.PageButton>
      );

      if (currentPage > 4) {
        pages.push(<S.Ellipsis key="start-ellipsis">...</S.Ellipsis>);
      }
    }

    // Show pages around current page
    for (let i = Math.max(1, currentPage - 1); i <= Math.min(totalPages, currentPage + 1); i++) {
      pages.push(
        <S.PageButton
          key={i}
          active={i === currentPage}
          onClick={() => onPageChange(i)}
          aria-current={i === currentPage ? 'page' : undefined}
        >
          {i}
        </S.PageButton>
      );
    }

    // Always show last page
    if (currentPage < totalPages - 2) {
      if (currentPage < totalPages - 3) {
        pages.push(<S.Ellipsis key="end-ellipsis">...</S.Ellipsis>);
      }

      pages.push(
        <S.PageButton key={totalPages} onClick={() => onPageChange(totalPages)}>
          {totalPages}
        </S.PageButton>
      );
    }

    return pages;
  };

  return (
    <S.PaginationContainer>
      <S.PaginationButton
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label="Previous page"
      >
        <CaretLeft weight="bold" />
      </S.PaginationButton>

      {renderPageNumbers()}

      <S.PaginationButton
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label="Next page"
      >
        <CaretRight weight="bold" />
      </S.PaginationButton>
    </S.PaginationContainer>
  );
};
